/** Settings › Brand kit. `?kit=` opens on one kit. */
export const BRAND_KITS_PATH = "/settings/brand-kits";

export const brandKitsPath = (kitId?: string | null): string => (kitId ? `${BRAND_KITS_PATH}?kit=${encodeURIComponent(kitId)}` : BRAND_KITS_PATH);

/** Where the page was opened from (router state), so it can offer the way back. */
export interface BrandKitsFrom {
  /** "step 3 of “Plan”" */
  label: string;
  /** The path to go back to. */
  path: string;
}

export const readBrandKitsFrom = (state: unknown): BrandKitsFrom | null => {
  const from = (state as { from?: Partial<BrandKitsFrom> } | null)?.from;
  return from && typeof from.label === "string" && typeof from.path === "string" ? { label: from.label, path: from.path } : null;
};
